import type { City } from 'contracts/cities'
import { apiGeneral } from 'services';
import { optionsMapper, multiSelectorOptionsMapper } from './utils';

export function useCityOptions() {
  const fetchCities = async (state: string | string[]) => {
    const stateString = Array.isArray(state)
      ? state.join(',')
      : state;

    const { data } = await apiGeneral.get<City[]>(
      `/cities?state=${stateString}`
    );

    const options = data.map((city) => {

      const { name, state: UF, ibge } = city;

      const label = Array.isArray(state) && state.length > 1
        ? `${name}/${UF}`
        : name;

      return {
        label,
        value: ibge.toString(),
      }
    });

    return {
      singleSelectOptions: options.map(optionsMapper),
      multiSelectOptions: options.map(multiSelectorOptionsMapper),
    };
  };

  return {
    fetchCities,
  };
}
